            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row style="width:100%">
          <sw-inputs
            inputTabla="multiple_servicios"
            inputCampo="name"
            :lg="4"
            :md="4">
          </sw-inputs>
          <sw-inputs
            inputTabla="multiple_servicios"
            inputCampo="afiliacion"
            :lg="4"
            :md="4">
          </sw-inputs>
          <sw-inputs
            inputTabla="multiple_servicios"
            inputCampo="valor"
            :lg="4"
            :md="4">
          </sw-inputs>
          <b-col class="pt-4">
            <b-form-checkbox
              v-model="beneficiarios"
              name="checkbox-1"
              >
              El servicio podrá incluir beneficiarios
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="servicio"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalservicio',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  data() 
  {
    return {
      beneficiarios: false
    }
  },
  async created()
  {
    await this.resetDataForm({state:'multiple_servicios'})
    if (this.dataIndex[this.namePath]!==false)
    {      
      await this.updateDataForm({state:'multiple_servicios', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].multiple_servicios})
    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  computed: { 
  },
  destroyed()
  {    
		this.resetDataIndex()
		this.resetDataForm()
		this.resetDataPost()
  },
  methods: {
    async save(event)
    {
      if(this.beneficiarios)
      {
        const await0 = this.updateDataForm({state: 'list_servicios',data: {id: null, name: this.dataForm[this.namePath].multiple_servicios.name, list:null}})
        const await1 = this.updateDataPost({ 
         data: { 
          data: [],
          route: 'save_all', 
          tablaPost: ['multiple_servicios','list_servicios'],
          tablaDelete:[],
          auditar:true,
          notaDelete: null
          }
        }) 
        await Promise.all([await0,await1])
      }
      else 
      {
        await this.updateDataPost({ 
         data: { 
          data: [],
          route: 'save_all', 
          tablaPost: ['multiple_servicios'],
          tablaDelete:[],
          auditar:true,
          notaDelete: null
          }
        }) 

      }
      this.$emit('save', { save: event.save, ftn: 'servicioFtn' } )
    }
  }
}
</script>
<style>
</style>